// extracted by mini-css-extract-plugin
module.exports = {"customerReport":"CustomerReport_customerReport__3hAzB"};